export var canUseDOM = function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};
export var canUseNative = function canUseNative() {
  return typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
};
/*
 Returns object:
 {
 isNative: boolean,
 isBrowser: boolean,
 isServer: boolean,
 }
 */

export var defineLocation = function defineLocation() {
  return {
    isNative: canUseNative(),
    isBrowser: !canUseNative() && canUseDOM(),
    isServer: !canUseNative() && !canUseDOM()
  };
};